/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_CASO (state, caso) {
    state.casos.push(caso)
  },
  SET_CASO (state, casos) {
    state.casos = casos
    state.meta.push(casos.meta)
  },
  SET_TOTAL_CASOS (state, total_casos) {
    state.total_casos = total_casos
  },
  SET_CASO_BY_ID (state, caso) {
    state.caso_by_id = caso
  },
  UPDATE_CASO (state, caso) {
    const productIndex = state.casos.findIndex((p) => p.id === caso.id)
    state.casos[productIndex] = caso
  },
  REMOVE_CASO (state, casoId) {
    const ItemIndex = state.casos.findIndex((p) => p.id === casoId)
    state.casos.splice(ItemIndex, 1)
  },
  DEVOLVER_INFORMACION_CASO (state, data) {
    state.devolver_informacion_caso = data
  },
  APRUEBA_CIERRE_CASO (state, data) {
    state.aprueba_cierre_caso = data
  }
}
